"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ContextInitializer_1 = require("./initialization/ContextInitializer");
var CoveoForSitecoreContext_1 = require("../ui/context/CoveoForSitecoreContext");
var coveo_search_ui_1 = require("coveo-search-ui");
var Context = (function () {
    function Context() {
    }
    Context.configureContext = function (contextElement) {
        if (typeof (contextElement) === "undefined" || contextElement === null) {
            throw Error("You must execute `configureContext` with an HTML element.");
        }
        var options = coveo_search_ui_1.ComponentOptions.initComponentOptions(contextElement, CoveoForSitecoreContext_1.CoveoForSitecoreContext);
        this.initializeWithContextOptions(contextElement, options);
    };
    Context.initializeWithContextOptions = function (contextElement, contextOptions) {
        var contextInitializer = new ContextInitializer_1.ContextInitializer();
        var fieldsHandler = contextInitializer.createFieldsHandler({
            externalFields: contextOptions.scExternalFields,
            prefix: contextOptions.scFieldPrefix,
            suffix: contextOptions.scFieldSuffix
        });
        var labels = contextInitializer.createLabelsHandler({
            labels: contextOptions.scLabels
        });
        var sourceName = contextOptions.scIndexSourceName;
        contextInitializer.initializePrebinding({
            fieldsHandler: fieldsHandler,
            context: contextOptions
        });
        contextInitializer.initializeUnderscoreFieldsHelpers(fieldsHandler);
        contextInitializer.initializeUnderscoreLabelsHelpers(labels);
        contextInitializer.initializeUnderscoreContextHelpers(sourceName);
        contextInitializer.initializeContextElement(contextElement);
        this.fields = fieldsHandler;
        this.labels = labels;
        this.element = contextElement;
    };
    return Context;
}());
exports.Context = Context;



//////////////////
// WEBPACK FOOTER
// ./src/base/Context.ts
// module id = 3
// module chunks = 13 14